/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-05-05 10:06:55
 * @FilePath: /unifyxp-v2-store-portal/src/config/routerConfig/mainPages/EditorPage/index.ts
 */
import ProductSet from '@/src/pages/ProductEditor/ProductSet/ProductSet';
import SimpleProductEditor from '@/src/pages/ProductEditor/SimpleProduct/SimpleProduct';

// import VariantProduct from '@/src/pages/ProductEditor/VariantProduct/VariantProduct';
import ProductReview from '@/src/pages/ProductReview/ProductReviewDetail';
import {
  AllInventoryDetail,
  AuditTrailCommunicationDetail,
  InventoryDetail,
  reportDetail,
  ReportSubscriptionDetail,
  StockDetail,
} from 'src/pages';
import VirtualProduct from 'src/pages/ProductEditor/VirtualProduct';
import { IRouteSubRoutes } from 'src/types/router';
import {
  productDetailPage,
  stockDetailPage,
  inventoryDetailPage,
  reviewDetailPage,
  communicationAuditTrailDetailPage,
  analyticsSubscriptionDetailPage,
  analyticsReportDetailPage,
} from '@/src/tools/permissions/storePermissions';
import { EPermissionSource } from 'src/types/common/resources';
import { storeRoutes } from 'src/tools/urlMap';

export const editorRoutes: IRouteSubRoutes[] = [
  {
    exact: true,
    path: storeRoutes.simpleProductDetail,
    component: SimpleProductEditor,
    isPrivate: true,
    permissionGroup: productDetailPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.productSetDetail, // '/product/productSet/:uuid',
    component: ProductSet,
    isPrivate: true,
    permissionGroup: productDetailPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.virtualProductDetail, //'/product/virtualProduct/:uuid',
    component: VirtualProduct,
    isPrivate: true,
    permissionGroup: productDetailPage,
    source: EPermissionSource.store,
  },

  {
    exact: true,
    path: storeRoutes.storeStockEdit, //'/stockEditor/:uuid?',
    component: StockDetail,
    isPrivate: true,
    permissionGroup: stockDetailPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.inventoryEdit, //'/inventory/:uuid',
    component: InventoryDetail,
    isPrivate: true,
    permissionGroup: inventoryDetailPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.allInventory, //'/allInventory/:productUuid',
    component: AllInventoryDetail,
    isPrivate: true,
    permissionGroup: inventoryDetailPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.reviewEdit, //'/review/:productUuid',
    component: ProductReview,
    isPrivate: true,
    permissionGroup: reviewDetailPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.communicationDetail, //'/communication/:logUuid',
    component: AuditTrailCommunicationDetail,
    isPrivate: true,
    permissionGroup: communicationAuditTrailDetailPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.reportSubscriptionDetail, // '/reportSubscription/:reportSubscriptionUuid',
    component: ReportSubscriptionDetail,
    isPrivate: true,
    permissionGroup: analyticsSubscriptionDetailPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.reportDetail, //'/report/:type/:reportUuid',
    component: reportDetail,
    isPrivate: true,
    permissionGroup: analyticsReportDetailPage,
    source: EPermissionSource.store,
  },
];
